import '@fortawesome/fontawesome-free/css/all.min.css'
import 'moment/locale/hr'
import './scss/style.scss'

import { createApp } from 'vue'
import App from './App.vue'

import store from './plugins/store.js'
import router from './plugins/router.js'
import lang, { applyLanguage } from './plugins/lang.js'
import api, { setupApi } from './plugins/api.js'
import { confirm } from './plugins/confirm.js'

const app = createApp(App)
app.use(store)
app.use(lang)
app.config.globalProperties.$api = api
app.config.globalProperties.$confirm = confirm

// On an expired/invalid token, drop everything and return to login.
setupApi(store, () => {
    store.commit('reset')
    router.push({ name: 'login' })
})

// Reconcile the persisted selected client against the clients the member can actually access right now.
function reconcileClient(clients) {
    if (clients.length === 1) {
        store.commit('setSelectedClient', clients[0].client_id)
    } else if (store.state.selectedClientId && !clients.find((c) => c.client_id === store.state.selectedClientId)) {
        store.commit('setSelectedClient', null)
    }
}

// Resolve the session before the first navigation so route guards see a settled auth state.
async function boot() {
    // Start from the device's remembered language; a logged-in member's saved choice overrides it below.
    applyLanguage(store.state.language)
    if (store.state.token) {
        const response = await api.get('session', null, { client: false })
        if (response.success) {
            store.commit('setEmail', response.data.email)
            store.commit('setClients', response.data.clients)
            if (response.data.language) applyLanguage(response.data.language)
            reconcileClient(response.data.clients)
        } else {
            store.commit('reset')
        }
    }
    app.use(router)
    app.mount('#app')
}

boot()
